import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

/**
 * @title 用于给APP框架增加状态管理器
 * @auth yzs
 */
export const useMobileRouterStore = defineStore('mobileRouter', {
    state: () => ({
        currentPage: ref({}),
        historyPageList: reactive([]),
        ssoLoginData: ref({})
    }),
    actions: {
        setSSOLoginData(data) {
            this.ssoLoginData = data
        },
        // 设置当前页数据
        setCurrentPage(page) {
            this.currentPage = ref(page)
        },
        // 设置历史记录页面
        setHistoryPageList(page) {
            const index = this.historyPageList.findIndex(item => item.id === page.id)
            if (index === -1) {
                this.historyPageList.push(page)
            }
        },
        // 编辑历史记录页面
        editHistoryPageList(index, page) {
            this.historyPageList[index] = page
        },
        // 删除历史记录页面 把后面的全部删除
        removeHistoryPageList(id) {
            if (this.historyPageList.length === 1) return
            const index = this.historyPageList.findIndex(item => item.id === id)
            if (index !== -1) {
                this.historyPageList.splice(index + 1)
            }
        },
        // 重构导航栏
        resetLocationUrl({ id, params }) {
            // let newUrl;
            let urlSearch = location.search
            // if(urlSearch == params) {
            //     newUrl = `/mobile/${id}${params ? `${params}` : ''}`
            // } else {
            //     newUrl = `/mobile/${id}${urlSearch ? `${urlSearch}` : ''}`
            // }
            let newUrl = `/mobile/${id}${params ? `${params}` : ''}`

            console.log(newUrl, urlSearch, params, 'newUrl')
            window.history.pushState({}, '', newUrl)
        }
    }
})